import type { TimelineNode } from "@/mocks/topics";

interface EventTimelineProps {
  nodes: TimelineNode[];
}

export default function EventTimeline({ nodes }: EventTimelineProps) {
  return (
    <ol className="relative mt-6 space-y-6 border-l border-background-300 pl-6">
      {nodes.map((node, index) => (
        <li key={`${node.time}-${index}`} className="relative">
          <span
            className={`absolute -left-[calc(1.5rem+1px)] top-1 flex h-4 w-4 items-center justify-center rounded-full border-2 ${
              index === 0
                ? "border-primary-500 bg-primary-500"
                : "border-background-300 bg-background-50"
            }`}
            aria-hidden="true"
          >
            {index === 0 && <span className="h-1.5 w-1.5 rounded-full bg-background-50"></span>}
          </span>
          <time className="inline-block rounded-md bg-background-100 px-2 py-0.5 text-xs font-medium text-foreground-600">
            {node.time}
          </time>
          <h4 className="mt-2 font-heading text-base font-bold text-foreground-950">{node.title}</h4>
          <p className="mt-1 text-sm leading-relaxed text-foreground-600">{node.desc}</p>
        </li>
      ))}
    </ol>
  );
}